import * as yup from "yup";

export const serviceProviderScheduleSchema = yup.object().shape({
  day: yup.string().required("Day is required"),
  startTime: yup.date().required("Start Time is required"),
  endTime: yup.date().required("End Time is required"),
});
